import React from "react";
import { Form } from 'antd';
import ConsultarArticulosAdjudicaciones from "../../../components/ConsultarArticulosAdjudicaciones/ConsultarArticulosAdjudicaciones"; //Se importa el componente para los catálogos

export default function ConsultarArticulosAdjudicacionesPrincipal(props) {
    const WrappedFormConsultarArticulosAdjudicaciones = Form.create({ name: 'consulta' })(ConsultarArticulosAdjudicaciones);
    return (
         <WrappedFormConsultarArticulosAdjudicaciones
            idTipoDocumentacion={props.location.state.idTipoDocumentacion}
         />
    );
}